/* eslint-disable @typescript-eslint/naming-convention */
import pushClevertapEvent from '../pushClevertapEvent';

export function settingAccountStart() {
  pushClevertapEvent('Setting Account Start');
}

export function settingAccountPersonalDetailsEditStart({ name, phone, email }) {
  pushClevertapEvent('Setting Account Personal Details Edit Start', {
    Name: name,
    Phone: phone,
    Email: email,
  });
}

export function settingAccountPersonalDetailsEditSuccess({
  name,
  phone,
  email,
}) {
  pushClevertapEvent('Setting Account Personal Details Edit Successful', {
    Name: name,
    Phone: phone,
    Email: email,
  });
}

export function settingAccountPersonalDetailsPhoneVerifyStart({ phone }) {
  pushClevertapEvent('Setting Account Personal Details Phone Verify Start', {
    Phone: phone,
  });
}

export function settingAccountPersonalDetailsPhoneVerifySuccess({ phone }) {
  pushClevertapEvent(
    'Setting Account Personal Details Phone Verify Successful',
    {
      Phone: phone,
    }
  );
}

export function settingAccountBusinessInfoEditStart({
  businessName,
  businessAddress,
  province,
  city,
  district,
  postalCode,
}) {
  pushClevertapEvent('Setting Account Business Info Edit Start', {
    'Business Name': businessName,
    'Business Address': businessAddress,
    Province: province,
    City: city,
    District: district,
    'Postal Code': postalCode,
  });
}

export function settingAccountBusinessInfoEditSuccessful({
  businessName,
  businessAddress,
  province,
  city,
  district,
  postalCode,
}) {
  pushClevertapEvent('Setting Account Business Info Edit Successful', {
    'Business Name': businessName,
    'Business Address': businessAddress,
    Province: province,
    City: city,
    District: district,
    'Postal Code': postalCode,
  });
}

export function settingAccountPasswordEdit() {
  pushClevertapEvent('Setting Account Password Edit');
}

export function settingAccountPasswordEditSuccessful() {
  pushClevertapEvent('Setting Account Password Edit Successful');
}

export function npwpStart() {
  pushClevertapEvent('NPWP Start');
}

export function npwpCreated(data) {
  pushClevertapEvent('NPWP Created', data);
}
